"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOptionFromOptions = getOptionFromOptions;

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * TypeGuard. Verifies that the argument is a Category.
 */
function isCategory(category) {
  return _typeof(category) === 'object' && 'items' in category;
}
/**
 * TypeGuard. Verifies that the argument is an Option.
 */


function isOption(option) {
  return _typeof(option) === 'object' && 'id' in option && 'label' in option && 'value' in option;
}
/**
 * Finds the option matching the provided optionID.
 */


function getOptionFromOptions(options, optionId) {
  if (!optionId || (0, _isEmpty.default)(options)) {
    return undefined;
  } // Using an actual for loop allows for an early return.


  var i = 0;

  for (i; i < options.length; i += 1) {
    var selectedOption = options[i];

    if (isCategory(selectedOption)) {
      var match = getOptionFromOptions(selectedOption.items, optionId);

      if (isOption(match)) {
        return match;
      }
    } else if (selectedOption.id === optionId) {
      return selectedOption;
    }
  }

  return undefined;
} // eslint-disable-next-line import/prefer-default-export